import { Radio as MantineRadio, RadioGroup as MantineRadioGroup } from '@mantine/core';
import type { RadioProps as MantineRadioProps, RadioGroupProps as MantineRadioGroupProps } from '@mantine/core';
import './Radio.css';

export interface RadioProps extends MantineRadioProps {}

export interface RadioGroupProps extends MantineRadioGroupProps {}

export function Radio({ className = '', ...props }: RadioProps) {
  return <MantineRadio className={`radio ${className}`.trim()} {...props} />;
}

export function RadioGroup({ className = '', ...props }: RadioGroupProps) {
  return <MantineRadioGroup className={`radio-group ${className}`.trim()} {...props} />;
}

Radio.Group = RadioGroup;
